var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2399_49632)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 28,
    fill: "#505D6F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 39.4936C31.5345 39.4936 31.1448 39.336 30.8306 39.0207C30.5153 38.7066 30.3577 38.3169 30.3577 37.8516V29.6418H22.1478C21.6826 29.6418 21.2924 29.4841 20.9771 29.1689C20.6629 28.8547 20.5059 28.465 20.5059 27.9998C20.5059 27.5346 20.6629 27.1443 20.9771 26.829C21.2924 26.5149 21.6826 26.3578 22.1478 26.3578H30.3577V18.1479C30.3577 17.6827 30.5153 17.2925 30.8306 16.9772C31.1448 16.663 31.5345 16.506 31.9997 16.506C32.4649 16.506 32.8552 16.663 33.1704 16.9772C33.4846 17.2925 33.6417 17.6827 33.6417 18.1479V26.3578H41.8515C42.3168 26.3578 42.7065 26.5149 43.0206 26.829C43.3359 27.1443 43.4935 27.5346 43.4935 27.9998C43.4935 28.465 43.3359 28.8547 43.0206 29.1689C42.7065 29.4841 42.3168 29.6418 41.8515 29.6418H33.6417V37.8516C33.6417 38.3169 33.4846 38.7066 33.1704 39.0207C32.8552 39.336 32.4649 39.4936 31.9997 39.4936Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2399_49632",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2399_49632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2399_49632",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimg);
export default __webpack_public_path__ + "static/media/uploadimg.ba3b347307bbdd7c89b59c844e45cd72.svg";
export { ForwardRef as ReactComponent };